<template>
    <vx-table class="xl:grid-cols-4-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader data-test="header">
            <div class="lg:pl-6">Organizational Unit</div>
            <div>Team</div>
            <div>Billable</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
